import utils from '../utils/string'

/**
 * @mixin
 */
export default {
    methods: {
        formatAsTitle: utils.formatAsTitle
    }
}
